import React, { PureComponent } from "react";
import Template from "../components/template/Template";
import Cookie from "js-cookie";
import AppRoutePath from "../router/AppRoutePath";
import IsEmpty from "../components/helpers/IsEmpty";

class Home extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
    if (
      !IsEmpty(Cookie.get("access_token")) &&
      !IsEmpty(Cookie.get("refresh_token"))
    ) {
      props.history.push(AppRoutePath.DASHBOARD);
    } else {
      props.history.push(AppRoutePath.LOGIN);
    }
  }

  render() {
    return (
      <Template>
        <div>Home</div>
      </Template>
    );
  }
}

export default Home;
